(function () {
  'use strict'

  /**
   * @ngdoc service
   * @name VoteApi
   * @module thismoment.glow.component.glow-vote.provider.vote-api
   *
   * @description
   * Allows the glow page and glow modules to access the user input
   */

  var MODULE_NAME = 'thismoment.glow.component.glow-vote.provider.vote-api'

  require('angular')
    .module(MODULE_NAME, [
      require('../../../../api/async')
    ])
    .provider('VoteApi', voteApiProvider)

  function voteApiProvider () {
    return {
      $get: voteApiService
    }
  }

  voteApiService.$inject = ['SdkConfig', 'ThismomentAsyncApi']
  function voteApiService (SdkConfig, ThismomentAsyncApi) {
    var API = ThismomentAsyncApi.configureResource(SdkConfig.get('content_cloud_url') + '/api/solution/v1/glow/contest-vote')

    return {
      post: postVote
    }

    function postVote (data) {
      var postBody = angular.merge({
        account_id: SdkConfig.get('account_id'),
        group_id: SdkConfig.get('group_id')
      }, data)

      return API.post({}, postBody)
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-vote/provider/vote-api.js